import React, { MutableRefObject, ReactNode } from 'react';
import { Formik, FormikProps, FormikConfig } from 'formik';

export type FormRefType<TValues extends Record<string, unknown>> =
  FormikProps<TValues> | null;

export interface IFormProps<TValues extends Record<string, unknown>>
  extends FormikConfig<TValues> {
  onValidChange?: (isValid: boolean) => void;
  initialValues: TValues;
  formRef?: MutableRefObject<FormRefType<TValues>>;
}

export function Form<TValues extends Record<string, unknown>>({
  children,
  initialValues,
  onValidChange,
  formRef,
  ...props
}: IFormProps<TValues>) {
  function renderChildren(formik: FormikProps<TValues>) {
    if (formRef && typeof formRef === 'object') {
      formRef.current = formik;
    }

    if (onValidChange) {
      onValidChange(formik.isValid && formik.dirty);
    }

    return children as ReactNode;
  }

  return (
    <Formik initialValues={initialValues} {...props}>
      {renderChildren}
    </Formik>
  );
}
